export enum PaymentMethod {
  CreditCard = 'creditcard',
  Mastercard = 'mastercard',
  Visa = 'visa',
  DirectDebit = 'directdebit',
  iDeal = 'ideal',
  Invoice = 'invoice',
}

export enum InvoiceAddressChoice {
  UseExistingAddress = 'Gebruik bestaand adres',
  UseOtherAddress = 'Gebruik ander adres',
}

export type Form = {
  referenceNumber: string
  paymentMethod: PaymentMethod
  paymentParams: string
  invoiceAddressChoice: InvoiceAddressChoice
  address: string
  postalCode: string
  city: string
  companyName: string
  country: string
}
